import { render, staticRenderFns } from "./NRInfo.vue?vue&type=template&id=3cb75f4a&scoped=true"
import script from "./NRInfo.vue?vue&type=script&lang=ts"
export * from "./NRInfo.vue?vue&type=script&lang=ts"
import style0 from "./NRInfo.vue?vue&type=style&index=0&id=3cb75f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb75f4a",
  null
  
)

export default component.exports